import { useState, useEffect } from "react";
import { Menu, X, Phone, LogIn } from "lucide-react";
import { Button } from "../ui/button";
import { logos, navLinks, contactInfo, dataStore365 } from "../../data/mock";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? "bg-[#050510]/80 backdrop-blur-2xl border-b border-white/[0.06] shadow-lg shadow-black/30"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button
            onClick={() => scrollToSection("#inicio")}
            className="flex-shrink-0"
          >
            <img
              src={logos.horizontal}
              alt="InnovArs Microsistemas"
              className="h-9 w-auto"
            />
          </button>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="text-sm font-medium text-white/60 hover:text-white transition-colors duration-300 relative group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-[#0077FF] group-hover:w-full transition-all duration-300" />
              </button>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-5">
            <a
              href={dataStore365.loginUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm text-cyan-400/70 hover:text-cyan-400 transition-colors duration-300 font-medium"
            >
              <LogIn size={14} />
              <span>DataStore365</span>
            </a>
            <span className="w-px h-4 bg-white/10" />
            <a
              href={`tel:${contactInfo.phone}`}
              className="flex items-center gap-2 text-sm text-white/40 hover:text-white/70 transition-colors duration-300"
            >
              <Phone size={14} />
              <span>{contactInfo.phone}</span>
            </a>
            <Button
              onClick={() => scrollToSection("#contacto")}
              className="bg-[#0077FF] hover:bg-[#0060DD] text-white text-sm px-6 h-10 rounded-lg transition-colors duration-300"
            >
              Contáctanos
            </Button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white/70 hover:text-white transition-colors"
            aria-label="Menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen
            ? "max-h-[400px] border-b border-white/[0.06]"
            : "max-h-0"
        }`}
      >
        <div className="bg-[#050510]/95 backdrop-blur-2xl px-6 py-6 space-y-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollToSection(link.href)}
              className="block w-full text-left text-white/60 hover:text-white transition-colors text-sm font-medium py-2"
            >
              {link.label}
            </button>
          ))}
          <a
            href={dataStore365.loginUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-cyan-400/80 hover:text-cyan-400 text-sm font-medium py-2"
          >
            <LogIn size={14} />
            Acceder a DataStore365
          </a>
          <Button
            onClick={() => scrollToSection("#contacto")}
            className="w-full bg-[#0077FF] hover:bg-[#0060DD] text-white text-sm rounded-lg mt-2"
          >
            Contáctanos
          </Button>
        </div>
      </div>
    </header>
  );
};
